import React from 'react';
import { ImgLazyLoader } from './ImgLazyLoader';

/* Even lazier */

export const LazyImg = (props) => {
  return <ImgLazyLoader><img {...props}/></ImgLazyLoader>;
};
